import React from "react"

function ThoughtBubble({ width = 24, height = 24, fill = "none", ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="6 6 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20.1 9.6C19.4 9.2 18.6 9 17.7 9C15.2 9 13.1 10.8 13.1 13.1C13.1 13.2 13.1 13.4 13.2 13.5C11.5 14.1 10.3 15.6 10.3 17.3C10.3 19.5 12.3 21.4 14.8 21.4C15.7 22.6 17.2 23.4 18.8 23.4C20.1 23.4 21.4 22.9 22.3 22C22.7 22.1 23 22.1 23.4 22.1C25.9 22.1 28 20.3 28 18C28 17 27.5 16 26.7 15.2C27.3 14.5 27.6 13.6 27.6 12.7C27.6 10.5 25.6 8.6 23 8.6C21.9 8.6 20.9 9 20.1 9.6Z"
        stroke="#003E4C"
        strokeWidth="0.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="12.3" cy="23.5" r="1.8" stroke="#003E4C" strokeWidth="0.75" />
      <circle cx="9.3" cy="26.1" r="1.2" stroke="#003E4C" strokeWidth="0.75" />
    </svg>
  )
}
export default ThoughtBubble
